/* eslint-disable */

import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { func, object, string } from 'prop-types'
import styled from 'styled-components'
import { useMutation } from '@apollo/client'
import qs from 'qs'

import { genericMessages } from '../../translations'
import {
  useAuthenticationState,
  useAuthenticationDispatch,
} from '../../contexts/AuthenticationContext'
import AuthenticationService from '../../services/ApiService/AuthenticationService'
import { LoginFlow } from './LoginFlow'
import { SignUpFlow } from './SignUpFlow'
import { useNotificationContext } from '../../contexts/NotificationContext'

const StyledLoginWrapper = styled.div``

export const AuthenticationFlow = ({ redirectUrl, onClose, openChild, ...rest }) => {
  const { formatMessage } = useIntl()
  const { showLogin, userTypeVisible } = useAuthenticationState()
  const [loginErrors, setLoginErrors] = useState()
  const [signupErrors, setSignupErrors] = useState()
  const authenticationDispatch = useAuthenticationDispatch()
  const { triggerNotification } = useNotificationContext()
  const params = qs.parse(window.location.search.slice(1))

  useEffect(() => {
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    } catch (error) {
      window.scrollTo(0, 0)
    }
  }, [showLogin])

  const handleFlowChange = () => {
    authenticationDispatch({
      type: useAuthenticationDispatch.ACTION_TYPES.SHOW_AUTHENTICATION,
      showLogin: !showLogin,
    })
  }

  const handleSocialRedirect = () => {
    if (params.redirect_token) {
      return { type: 'token', value: params.redirect_token }
    }
    if (params.redirect_url) {
      return { type: 'token', value: btoa(params.redirect_url) }
    }

    return {
      type: 'token',
      value: btoa(window.location),
    }
  }

  const handleEmailRedirect = () => {
    if (params.redirect_token) {
      return { type: 'token', value: params.redirect_token }
    }
    if (params.redirect_url) {
      return { type: 'token', value: btoa(params.redirect_url) }
    }

    return { type: 'token', value: btoa(window.location.href) }
  }

  const handleLogin = (values) => {
    const service = new AuthenticationService()
    const params = {
      user: values,
      redirectObject: handleEmailRedirect(),
    }

    service
      .signInUser(params)
      .then((result) => {
        if (result.status === 201) {
          return result.json()
        } else if (result.status === 422) {
          setLoginErrors({ message: 'Email or password is invalid.' })
        } else {
          setLoginErrors({ message: 'Internal server error ' })
        }
      })
      .then((res) => {
        if (res?.redirectUrl) window.location.href = res.redirectUrl
        if (res) onClose()
      })
      .catch((err) => console.log('err', err))
  }

  const onPasswordlessLogin = (values) => {
    const service = new AuthenticationService()

    service
      .passwordlessSignIn(values.email, handleEmailRedirect())
      .then((result) => {
        if (result.status === 200) {
          return result.json()
        }
        triggerNotification(result?.message, true)
      })
      // eslint-disable-next-line
      .then((result) => {
        triggerNotification(result.message)
      })
      .catch(() => {})
  }

  const handleSignUp = (values) => {
    const service = new AuthenticationService()
    const params = {
      user: values,
      captcha: values.captcha,
      redirectObject: handleEmailRedirect(),
    }

    return service
      .createUser(params)
      .then((result) => {
        const hasErrors = result.hasOwnProperty('errors')

        if (
          hasErrors &&
          (result.errors.hasOwnProperty('email') ||
            result.errors.hasOwnProperty('username') ||
            result.errors.hasOwnProperty('password') ||
            result.errors.hasOwnProperty('passwordConfirmation') ||
            result.errors.hasOwnProperty('base'))
        ) {
          const err = {}
          Object.keys(result.errors).map((key) => {
            err[key] = result.errors[key][0]
          })
          setSignupErrors(err)
        } else {
          return result.json()
        }
      })
      .then((response) => {
        if (response?.user?.id) {
          authenticationDispatch({
            type: useAuthenticationDispatch.ACTION_TYPES.UPDATE_USER,
            user: response.user,
          })
          onClose()
        } else {
          if (response?.errors) {
            const err = {}
            Object.keys(response.errors).map((key) => {
              err[key] = response.errors[key][0]
            })
            triggerNotification(`${Object.entries(err)[0][0]} ${Object.entries(err)[0][1]}`, true)
            setSignupErrors(err)
          } else if (response.status === 429) {
            triggerNotification(formatMessage(genericMessages.error429), true)
          } else {
            triggerNotification(null, true)
          }
        }
      })
  }

  return (
    <StyledLoginWrapper {...rest}>
      {showLogin ? (
        <LoginFlow
          onFlowChange={handleFlowChange}
          onLogin={handleLogin}
          onPasswordlessLogin={onPasswordlessLogin}
          errors={loginErrors}
          handleRedirect={handleSocialRedirect}
          openChild={openChild}
        />
      ) : (
        <SignUpFlow
          onFlowChange={handleFlowChange}
          onSignUp={handleSignUp}
          errors={signupErrors}
          handleRedirect={handleSocialRedirect}
          userTypeVisible={userTypeVisible}
          openChild={openChild}
        />
      )}
    </StyledLoginWrapper>
  )
}

AuthenticationFlow.propTypes = {
  redirectUrl: string,
  onClose: func,
  openChild: func,
}
